// src/components/map/ViewLocationMap.jsx
import React from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";

const defaultPosition = [12.9716, 77.5946];
const defaultZoom = 5;
const myLocationZoom = 14;

// Fix marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

const ViewLocationMap = ({
  lat,
  lng,
  label = "Location",
  className = "",
  labelClassName = "",
}) => {
  const position = lat && lng ? [lat, lng] : null;

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          className={`block mb-2 text-fs_14 md:text-fs_16 font-fw_400 capitalize ${labelClassName}`}
        >
          {label} {lat}
        </label>
      )}

      <MapContainer
        center={position || defaultPosition}
        zoom={position ? myLocationZoom : defaultZoom}
        scrollWheelZoom={true}
        dragging={true}
        doubleClickZoom={true}
        zoomControl={true}
        style={{ height: "300px", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {position && <Marker position={position} />}
      </MapContainer>
    </div>
  );
};

export default ViewLocationMap;
